import wrapWithProvider from './src/wrapWithProvider';

export const wrapRootElement = wrapWithProvider;
